<template>
    <div class="ku-food">
        <van-grid class="grid" :column-num="tab_num">
            <van-grid-item v-for="(item, index) in tab_A" :key="index" @click="get_list(item)" :class="{active: item.active === 1, stock_no: item.stock > 0}">
                <span>{{ item.name }}</span>
                <span>{{ item.en_name }}</span>
            </van-grid-item>
        </van-grid>

        <van-row class='food-list' :class="{in_only: item.in_only === 1, is_new: item.new == 1, is_wechat: item.wechat === 1, stock_no: item.stock == 0, status_hide: item.show_status === 0, category_no: item.category_id === 0 || item.category_hc_id === 0}" v-for="(item, index) in list" :key="index" @click="set_edit(item)">
            <van-col span="7" class="title">
                <span>{{ item.name }}</span>
                <span v-if="!item.morning || !item.in || !item.afternoon || !item.night">
                    <label v-if="item.morning">早</label>
                    <label v-if="item.in">中</label>
                    <label v-if="item.afternoon">下</label>
                    <label v-if="item.night">晚</label>
                </span>
            </van-col>
            <van-col span="2">{{ item.price }}</van-col>
            <van-col span="5">
                <span @click.stop="setFood(item, 'wai_mai')" :class="{'blue': item.wai_mai}">{{ item.wai_mai ? '*' : '' }}外卖</span>
                <span @click.stop="setFood(item, 'tang_shi')" :class="{'blue': item.tang_shi}">{{ item.tang_shi ? '*' : '' }}堂食</span>
            </van-col>
            <van-col span="10">
                <span>{{ item.raise_text }}</span>
            </van-col>
        </van-row>

<!--        <van-button @click="set_add(1)" class="add-button babrc_2" type="primary">新增套餐</van-button>-->
        <van-button @click="set_add(2)" class="add-button" type="primary">新增餐品</van-button>

        <van-popup closeable close-icon="close" class="food-edit" v-model="edit_show" position="bottom" @click-overlay="click_overlay">
            <div class="top">
                <div class="top-left">
                    <van-uploader
                        :after-read="afterRead"
                        :before-delete="image_delete"
                        v-model="image"
                        upload-text="展示图"
                        :max-count="1"
                        :max-size="10 * 1024 * 1024"
                        @oversize="onOversize"
                    />
                </div>
                <div class="hut-right">
                    <div class="top-center">
                        <van-button @click="set_top('morning')" :class="row.morning === 1 ? 'active' : ''">早餐</van-button>
                        <van-button @click="set_top('in')" :class="row.in === 1 ? 'active' : ''">中餐</van-button>
                        <van-button @click="set_top('afternoon')" :class="row.afternoon === 1 ? 'active' : ''">下午</van-button>
                        <van-button @click="set_top('night')" :class="row.night === 1 ? 'active' : ''">晚餐</van-button>
                    </div>

                    <div class="top-right">
                        <div>
                            <van-button @click="set_top('top')" :class="row.top === 1 ? 'active' : ''">自助机促销</van-button>
                            <van-button @click="set_top('wechat_top')" :class="{active : row.wechat_top === 1}">微信促销</van-button>
                            <van-button @click="set_meal()" :class="row.set_meal === 3 ? 'active' : ''">套餐产品</van-button>
                        </div>
                        <div>
                            <van-button @click="set_top('new')" :class="row.new === 1 ? 'active' : ''">微信置顶</van-button>
                            <van-button @click="set_top('wechat')" :class="{active : row.wechat === 1}">微信专属</van-button>
                            <van-button @click="set_top('in_only')" :class="row.in_only === 1 ? 'active' : ''">早餐专属</van-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="center">
<!--                <div class="max set_meal">-->
<!--                    <van-field class="s1" v-model="row.name" placeholder="请输入商品名称" />-->
<!--                    <van-field class="s2" readonly clickable :value="value" placeholder="选择类别" @click="onShowPicker('')" />-->
<!--                    <van-field class="s2" v-model="row.discount" type="number" label="优惠" placeholder="优惠金额" />-->
<!--                    <van-field class="s2" v-model="row.sort" label="排序" type="number" placeholder="排序" />-->
<!--                </div>-->

                <div class="max">
                    <van-field v-model="row.name" label="名称" placeholder="请输入商品名称" />
                    <van-field v-model="row.price" label="价格" placeholder="请输入商品价格" />
                </div>
                <div class="max">
                    <van-field v-model="row.sort" label="排序" type="number" placeholder="排序" />
                    <van-field v-model="row.pack_price" type="number" label="打包费" placeholder="打包费" />
                </div>
                <div class="max">
                    <van-field v-model="row.stock" label="库存" type="number" placeholder="库存" />
                    <van-field readonly clickable label="类别" :value="value" placeholder="选择类别" @click="onShowPicker('')" />
                </div>
                <div class="max" v-show="row.set_meal === 1">
                    <van-field readonly clickable label="后厨类别" :value="hc_value" placeholder="选择类别" @click="onShowPicker('hc')" />
                    <van-field readonly clickable label="关联条件" :value="in_raise" placeholder="选择关联条件" @click="onShowRaise()" />
                </div>
            </div>

            <div class="foot-raise" v-show="row.set_meal !== 3">
                <van-button @click="set_raise(index)" :key="index" v-for="(item, index) in tab_B" v-show="item.hidden === 0" :class="item.str === 1 ? 'active' : ''" >
                    {{ item.name }} <span>{{ item.price > 0 ? item.price : ''}}</span></van-button>
            </div>

            <div class="foot-raise foot-category" v-show="row.set_meal === 3">
                <div class="title" @click="is_meal = !is_meal"><span>配置固定套餐点此展开</span></div>
                <div v-show="is_meal">
                <van-button @click="set_category(c_vo, key)" :key="key" v-for="(c_vo, key) in tab_A"  :class="c_vo.str === 1 ? 'active' : ''" >
                    {{ c_vo.name }} <span>{{ c_vo.price > 0 ? c_vo.price : ''}}</span></van-button>
                </div>
            </div>

            <div class="foot-raise foot-category foot-category-1" v-show="row.set_meal === 3 && is_meal">
                <h2>选择餐品</h2>
                <van-button @click="set_meal_list(l_vo)" :key="key" v-for="(l_vo, key) in meal_list"  :class="l_vo.meal_str === 1 ? 'active' : ''" >{{ l_vo.name }}</van-button>
            </div>

            <div class="ku-submit">
                <van-button class="s1" @click="food_status(row)" v-if="row.id && !row.show_status" type="danger">上架</van-button>
                <van-button class="s1" @click="food_status(row)" v-if="row.id && row.show_status" type="danger">下架</van-button>
                <van-button class="s2" @click="food_del(row)" v-if="row.id" type="danger">删除</van-button>
                <van-button class="s3" @click="set_submit" type="danger">确定</van-button>
            </div>

        </van-popup>

        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                :default-index="value_index_in"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            />
        </van-popup>

        <van-popup v-model="showRaise" round position="bottom">
            <van-picker
                show-toolbar
                :columns="raise_columns"
                @cancel="showRaise = false"
                @confirm="onConfirmRaise"
            />
        </van-popup>


        <FootTab :tab-key="tabKey"></FootTab>
    </div>
</template>

<script>
import Vue from 'vue';
import {Grid, GridItem, Col, Row, Popup, Button, Uploader, Field, Checkbox, Dialog, Picker, Notify} from 'vant';
import FootTab from '@/components/foot'

Vue.use(Grid).use(GridItem).use(Col).use(Row).use(Popup).use(Button).use(Uploader)
.use(Field).use(Checkbox).use(Picker);
    export default {
        name: "index",
        data() {
            return {
                tabKey: 'food',
                tab_A: [],
                tab_B: [],
                tab_num: 0,
                tab_id: 0,
                value: '',
                hc_value: '',
                value_index: 0,
                hc_value_index: 0,
                value_index_in: 0,
                in_raise: '无',
                showPicker: false,
                showRaise: false,
                showPicker_type: '',
                columns: [],
                raise_columns: [],
                list: [],
                meal_list: [],

                edit_show: false,
                image: [],
                is_meal: false,

                row: {
                    id: '', // ID
                    name: '', // 名称
                    category_id: 0,
                    category_hc_id: 0,
                    in_raise: 0,
                    image: '', // 图片
                    price: '', // 价格
                    discount: '', // 优惠
                    pack_price: '', // 打包费
                    stock: '', // 库存
                    sort: 5, // 排序
                    morning: 0,
                    in: 0,
                    afternoon: 0,
                    night: 0,
                    in_only: 0,
                    new: 0,
                    top: 0,

                    set_meal: 1,

                    raise: [],
                    category: [],
                    meal_list: [],

                    wechat_top: 0,
                    wechat: 0,

                }
            }
        },
        components: {
            FootTab
        },
        mounted() {
            this.tab_foodCategory()
        },
        methods: {
            onConfirm(value, index) {
                if (this.showPicker_type === 'hc') {
                    if (index > 0) {
                        this.hc_value = value;
                        this.row.category_hc_id = this.tab_A[index - 1].id;
                    } else {
                        this.hc_value = '';
                        this.row.category_hc_id = 0;
                    }
                } else {
                    if (index > 0) {
                        this.value = value;
                        this.row.category_id = this.tab_A[index - 1].id;
                    } else {
                        this.value = '';
                        this.row.category_id = 0;
                    }
                }
                this.showPicker = false;
            },
            onConfirmRaise(value, index) {
                this.in_raise = value;
                this.row.in_raise = index === 0 ? 0 : this.tab_B[index - 1].id;
                this.showRaise = false;
            },
            // 获取分类
            tab_foodCategory() {
                let _this = this
                _this.tab_A = []
                _this.columns = []
                _this.list = []
                // 获取全部类别
                _this.$API.foodCategory().then(res => {
                    if (res.data.list.length === 0) {
                        Dialog.alert({
                            title: '标题',
                            message: '请先设置菜品类别',
                        }).then(() => {
                            this.$router.push("/shop")
                        });
                    }
                    _this.columns.push('请选择')
                    res.data.list.forEach(function (item, index) {
                        item.active = 0
                        item.str = 0
                        if (index === 0) {
                            item.active = 1
                            console.log(_this.tab_id)
                            if (_this.tab_id === 0) {
                                _this.tab_id = item.id
                                _this.row.category_id = item.id
                                _this.row.category_hc_id = item.id
                                _this.value = item.name
                                _this.hc_value = item.name
                            }
                        }
                        _this.tab_A.push(item)
                        console.log(item.name)
                        _this.columns.push(item.name)
                    });
                    _this.tab_num = res.data.total
                    _this.tab_list(_this.tab_id)
                })
            },
            tab_list(id) {
                let _this = this
                _this.tab_B = []
                _this.raise_columns = ['无']
                // 全部商品
                _this.$API.foodList({type: id}).then(res => {
                    _this.list = res.data
                })

                // 获取全部附加条件
                _this.$API.foodRaise().then(res => {
                    res.data.list.forEach(function (item) {
                        if (item.show_status === 0 || item.show_status === '0') { return }
                        item.str = 0
                        item.hidden = 0
                        _this.tab_B.push(item)
                        _this.raise_columns.push(item.name)
                    });
                })
            },
            get_list(item) {
                this.tab_A.forEach(function (vo) {
                    vo.active = 0
                });
                console.log(item)
                item.active = 1
                this.row.category_id = item.id
                this.row.category_hc_id = item.id
                this.value = item.name
                this.hc_value = item.name
                this.tab_list(item.id)
            },
            get_meal_list(item) {
                let _this = this
                // 全部商品
                _this.$API.foodList({type: item.id, id:_this.row.id}).then(res => {
                    res.data.forEach(v => {
                        v.meal_str = 0
                        if (_this.row.meal_list.indexOf(v.id) > -1) {
                            v.meal_str = 1
                        }
                    })
                    _this.meal_list = res.data
                })
            },
            // 图片上传
            afterRead(file) {
                file.status = 'uploading';
                file.message = '上传中...';

                let formData = new FormData();
                formData.append("file", file.file);

                this.$API.upload(formData).then(res => {
                    file.status = 'done'
                    this.row.image = res.data.url
                }).catch(() => {
                    file.status = 'failed'
                    file.message = '上传失败'
                })
            },
            onOversize(file) {
                console.log(file);
                Dialog.alert({message: '文件大小不能超过 10 mb'});
            },
            image_delete(file) {
                console.log(file)
                this.row.image = ''
                return true;
            },
            set_top(val) {
                this.row[val] = this.row[val] === 1 ? 0 : 1
                console.log(this.row)
            },
            set_meal() {
               this.row.set_meal = this.row.set_meal === 3 ? 1 : 3;
            },
            set_raise(val) {
                this.tab_B[val].str = this.tab_B[val].str === 1 ? 0 : 1
            },
            set_category(item, val) {
                this.tab_A.forEach(v => {
                    v.str = 0
                })
                this.tab_A[val].str = 1
                this.get_meal_list(item)
            },
            set_meal_list(item) {
                // 检查row.meal_list 有没有id，有则删除，没有则添加id
                let index = this.row.meal_list.indexOf(item.id)
                if (index > -1) {
                    this.row.meal_list.splice(index, 1)
                } else {
                    this.row.meal_list.push(item.id)
                }
                item.meal_str = item.meal_str === 1 ? 0 : 1
            },
            click_overlay() {
                this.edit_show = true
                return false
            },
            setFood(item, type) {
                let _this = this
                console.log(item)
                Dialog.confirm({
                    title: '餐品设置',
                    message: '确认要修改餐品(' + item.name + ')' + (type === 'tang_shi' ? '堂食' : '外卖') + '状态吗？',
                }).then(() => {
                    let value = 0;
                    if (type === 'tang_shi') {
                        value = item.tang_shi === 1 ? 0 : 1
                    } else {
                        value = item.wai_mai === 1 ? 0 : 1
                    }
                    _this.$API.setFood({
                        id: item.id,
                        type: type,
                        value: value
                    }).then(() => {
                        if (type === 'tang_shi') {
                            item.tang_shi = item.tang_shi === 1 ? 0 : 1
                        } else {
                            item.wai_mai = item.wai_mai === 1 ? 0 : 1
                        }
                    })
                });
            },
            set_add(type) {
                let _this = this
                _this.edit_show = true
                _this.image = []
                _this.row.in_raise = 0 // 关联ID
                _this.in_raise = '无'    // 关联名字
                _this.row.id = '' // ID
                _this.row.name = '' // 名称
                _this.row.image = '' // 图片
                _this.row.price = '' // 价格
                _this.row.discount = '' // 优惠
                _this.row.pack_price = '' // 打包费
                _this.row.stock = '' // 库存
                _this.row.sort = 5 // 排序
                _this.row.morning = 0
                _this.row.in = 0
                _this.row.afternoon = 0
                _this.row.night = 0
                _this.row.new = 0
                _this.row.top = 0
                _this.row.set_meal = type === 1 ? 3 : 1
                _this.row.raise = []
                _this.row.category = []
                _this.row.meal_list = []
                _this.is_meal = false
                _this.value = ''
                _this.hc_value = ''
                _this.value_index = 0
                _this.hc_value_index = 0
            },
            set_edit(item) {
                let _this = this
                _this.edit_show = true
                _this.row = item
                _this.in_raise = '无'
                _this.image = [{url: item.image_url}]
                _this.value = ''
                _this.hc_value = ''
                _this.value_index = 0
                _this.hc_value_index = 0
                _this.tab_A.forEach(function (vo, key) {
                    if (item.category_id === vo.id) {
                        _this.value = vo.name
                        _this.value_index = key + 1
                    }
                    if (item.category_hc_id === vo.id) {
                        _this.hc_value = vo.name
                        _this.hc_value_index = key + 1
                    }
                    vo.str = 0
                });
                _this.tab_B.forEach(function (vo) {
                    vo.str = 0
                    vo.hidden = 0
                    if (item.in_raise > 0) {
                        if (item.in_raise === vo.id) {
                            _this.in_raise = vo.name
                            vo.hidden = 1
                        }
                    }
                });
                if (item.category.length > 0) {
                    _this.tab_A.forEach(function (vo) {
                        item.category.forEach(function (val) {
                            if (val.category_id === vo.id) {
                                vo.str = 1
                            }
                        })
                    });
                }
                if (item.raise.length > 0) {
                    _this.tab_B.forEach(function (vo) {
                        item.raise.forEach(function (val) {
                            if (val.raise_id === vo.id) {
                                vo.str = 1
                            }
                        })
                    });
                }
                _this.meal_list = []
                if (item.set_meal === 3) {
                    // 切换到第一分类
                    _this.tab_A.forEach((vo, key) => {
                        if (key === 0) {
                            vo.str = 1
                            _this.get_meal_list(vo)
                        } else {
                            vo.str = 0
                        }
                    });
                }
            },
            set_submit() {
                let _this = this
                this.row.category = []
                this.tab_A.forEach(function (item) {
                    if (item.str === 1) {
                        _this.row.category.push(item.id)
                    }
                })
                this.row.raise = []
                this.tab_B.forEach(function (item) {
                    if (item.str === 1) {
                        _this.row.raise.push(item.id)
                    }
                })
                if (this.row.name.length <= 0) {
                    Dialog.alert({message: '请输入名称'})
                    return false
                }
                if (this.row.image.length <= 0 && !this.row.set_meal) {
                    // Dialog.alert({message: '请上传图片'})
                    // return false
                }
                if (this.row.set_meal !== true) {
                    if (this.row.price.length <= 0 || this.row.price <= 0) {
                        Dialog.alert({message: '请输入正确金额'})
                        return false
                    }
                    if (this.row.stock.length <= 0 || this.row.stock <= 0) {
                        Dialog.alert({message: '请输入库存数量'})
                        return false
                    }
                } else {
                    if (this.row.category.length <= 0) {
                        Dialog.alert({message: '请选择套餐组合'})
                        return false
                    }
                }

                this.$API.foodSave(this.row).then(() => {
                    this.tab_A.forEach(function (vo) {
                        if (vo.id === _this.row.category_id) {
                            vo.active = 1
                        } else {
                            vo.active = 0
                        }
                    });
                    _this.edit_show = false
                    _this.tab_list(_this.row.category_id)
                    Notify({ type: 'success', message: '保存成功' });
                })
            },
            // 餐品上下架
            food_status(item) {
                let _this = this
                let title = item.show_status === 1 ? '下架' : '上架';
                let status = item.show_status === 1 ? 0 : 1;
                Dialog.confirm({
                    title: '餐品' + title,
                    message: '确认要' + title + '餐品(' + item.name + ')吗？',
                }).then(() => {
                    _this.$API.foodStatus({id: item.id, status: status, type: item.category_id}).then(res => {
                        _this.list = res.data
                        _this.edit_show = false
                        _this.tab_list(item.category_id)
                        Notify({ type: 'success', message: title + '成功' });
                    })
                }).catch(() => {
                });
            },
            // 删除餐品
            food_del(item) {
                let _this = this
                Dialog.confirm({
                    title: '删除餐品',
                    message: '确认要删除餐品(' + item.name + ')吗？',
                }).then(() => {
                    _this.$API.foodDel({id: item.id, type: item.category_id}).then(res => {
                        _this.list = res.data
                        _this.edit_show = false
                        _this.tab_list(item.category_id)
                        Notify({ type: 'success', message: '删除成功' });
                    })
                }).catch(() => {
                });
            },
            onShowPicker(type) {
                this.showPicker = true;
                this.showPicker_type = type;
                this.value_index_in = type === 'hc' ? this.hc_value_index : this.value_index
            },
            onShowRaise() {
                this.showRaise = true
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "/src/styles/base.less";
    .ku-food {
        padding-bottom: 120px;
        .grid {
            .van-grid-item {
                font-size: 30px;
                line-height: 40px;
                overflow: hidden;

                /deep/ .van-grid-item__content {
                    padding: 10px 0 0 0;
                    background: #DDD5C2;
                    border-bottom: 8px solid #DC561A;
                    &::after {
                        border: 0;
                    }
                }
                span {
                    &:nth-child(1) {
                        width: 64px;
                        height: 80px;
                        font-weight: bold;
                        overflow: hidden;
                        color: #70675C;
                    }
                    &:nth-child(2) {
                        width: 100%;
                        height: 40px;
                        overflow: hidden;
                        color: #C7AD8F;
                    }
                }
                &.stock_no {
                    span {
                        color: #f00;
                    }
                }
                &.active {
                    /deep/ .van-grid-item__content {
                        background: #DC561A;
                    }
                    span {
                        &:nth-child(1) {
                            color: #fff;
                        }
                    }
                    &.stock_no {
                        span {
                            color: #ffff00;
                        }
                    }
                }
            }
        }

        .food-list {
            line-height: 50px;
            border-bottom: 2px solid #BAE2CD;
            .title {
                color: #009be4;
                label {
                    width: 26px;
                    height: 26px;
                    line-height: 28px;
                    text-align: center;
                    background: #808080;
                    color: #FCFCFC;
                    border-radius: 100%;
                    font-size: 18px;
                    display: inline-block;
                    margin: 2px 0 0 2px;
                }
            }
            span {
                padding: 0 5px;
            }
            .van-col {
                font-size: 26px;
                &:nth-child(1) {
                    text-align: left;
                    padding-left: 10px;
                }
                &:nth-child(4) {
                    text-align: left;
                    padding-right: 10px;
                }
            }
            &.in_only {
                color: #26A670;
                .title {
                    color: #26A670;
                }
                .van-col {
                    .blue {
                        color: #26A670;
                    }
                }
            }
            &.is_new {
                .title {
                    color: purple;
                }
            }
            &.is_wechat {
                color: #DC561A;
                .title {
                    color: #DC561A;
                }
                .van-col {
                    .blue {
                        color: #DC561A;
                    }
                }
            }
            &.stock_no {
                color: #f00;
                .title {
                    color: #f00;
                }
                .van-col {
                    .blue {
                        color: #f00;
                    }
                }
            }
            &.status_hide {
                color: #ddd;
                .title {
                    color: #ddd;
                }
                .van-col {
                    .blue {
                        color: #ddd;
                    }
                }
            }
            &.category_no {
                color: #DC561A;
                .title {
                    color: #DC561A;
                }
                .van-col {
                    .blue {
                        color: #DC561A;
                    }
                }
            }
        }
        .food-edit {
            width: 100%;
            height: 90%;
            background: #898888;
            /deep/.van-popup__close-icon--top-right {
                top: 10px;
                right: 10px;
            }
            .top {
                padding: 40px 20px;
                width: 100%;
                height: 220px;
                display: flex;
                flex-direction: row;
                .top-left {
                    width: 220px;
                    height: 220px;
                    float: left;
                    /deep/ .van-uploader__preview {
                        .van-image {
                            width: 140px;
                            height: 140px;
                        }
                        .van-uploader__preview-delete {
                            width: 25px;
                            height: 25px;
                            top: -10px;
                            right: -10px;
                            background: white;
                            border-radius: 50%;
                            .van-uploader__preview-delete-icon {
                                font-size: 40px;
                                color: black;
                                right: -8px;
                                top: -6px;
                            }
                        }
                    }
                }
                .top-center {
                    width: 580px;
                    float: left;
                    .s1 {
                        width: 100%;
                        height: 88px;
                        float: left;
                        .van-field {
                            width: 300px;
                            height: 60px;
                            line-height: 60px;
                            padding: 0 20px;
                            border-radius: 10px;
                            float: left;
                        }
                        .van-checkbox {
                            font-size: 26px;
                            margin: 10px 0 0 20px;
                            float: right;
                            /deep/ .van-checkbox__icon {
                                background: #fff;
                            }
                            /deep/ .van-checkbox__label {
                                color: #fff;
                            }
                        }
                    }
                    .van-button {
                        width: 110px;
                        font-size: 24px;
                        padding: 0;
                        margin-right: 10px;
                        margin-top: 6px;
                        border-radius: 10px;
                        height: 50px;
                        background: #AAABAA;
                        border-color: #AAABAA;
                        color: #fff;
                        float: left;
                        &.active {
                            background: #1E9B8E;
                            border-color: #1E9B8E;
                        }
                    }
                }
            }
            .top-right {
                width: 580px;
                padding: 20px 0;
                float: left;
                display: flex;
                flex-direction: column;
                div {
                    margin-bottom: 15px;
                    .van-button {
                        width: 130px;
                        font-size: 24px;
                        padding: 0;
                        border-radius: 10px;
                        height: 50px;
                        background: #AAABAA;
                        border-color: #AAABAA;
                        color: #fff;
                        float: left;
                        margin-right: 10px;

                        &.active {
                            background: #1E9B8E;
                            border-color: #1E9B8E;
                        }
                    }
                }
            }
            .center {
                width: 98%;
                margin: 0 auto;
                display: inline-block;
                .van-field {
                    /deep/ .van-field__label {
                        width: 120px;
                    }
                }
                .max {
                    width: 100%;
                    position: relative;
                    min-height: 60px;
                    .van-field {
                        width: 50%;
                        height: 60px;
                        float: left;
                        line-height: 60px;
                        padding: 0 16px;
                        font-size: 24px;
                    }
                    .s1 {
                        width: 35%;
                        border-radius: 20px;
                        margin: 0 5px;
                    }
                    .s2 {
                        width: 19%;
                        border-radius: 20px;
                        margin: 0 5px;
                        /deep/ .van-field__label {
                            width: 60px;
                            margin: 0;
                        }
                    }
                }
                .set_meal {
                    margin: 50px 0 30px 0;
                }
                .top-right {
                    width: 100%;
                    .van-button {
                        margin: 0 5px;
                        float: left;
                        &:nth-child(4),&:nth-child(5) {
                            float: right;
                        }
                    }
                }
            }
            .foot-raise {
                text-align: left;
                padding: 30px 10px;
                display: inline-block;
                width: 100%;
                .van-button {
                    width: 138px;
                    font-size: 24px;
                    padding: 0;
                    margin-right: 8px;
                    margin-top: 20px;
                    border-radius: 10px;
                    height: 50px;
                    background: #FFF;
                    border-color: #FFF;
                    &.active {
                        background: #1E9B8E;
                        border-color: #1E9B8E;
                        color: #fff;
                        span > span {
                            color: #C6D739;
                        }
                    }
                }
            }
            .foot-category {
                .van-button {
                    background: white;
                    color: #000;
                }
                .title {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    span {
                        background: #1E9B8E;
                        border-color: #1E9B8E;
                        color: #fff;
                        padding: 10px 20px;
                        border-radius: 15px;
                        font-size: 26px;
                    }
                }
            }
            .foot-category-1 {
                .van-button {
                    width: 230px;
                    background: white;
                    color: #000;
                }
            }
            .ku-submit {
                margin: 0 auto;
                text-align: center;
                .van-button {
                    width: 160px;
                    height: 70px;
                    margin: 0 5px;
                    border-radius: 5px;
                    border: 0;
                    &.s1 {
                        background: #9c7c52;
                    }
                    &.s2 {
                        background: #42210b;
                    }
                    &.s3 {
                        background: #ed891e;
                    }
                }
            }
        }
        .add-button {
            width: 200px;
            margin: 30px 5px;
        }
    }

</style>
